var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProgramPage',{attrs:{"title":_vm.$t('Courses').toString(),"empty":_vm.emptyText}},[_c('div',{staticClass:"coursesPage__list"},_vm._l((_vm.courses),function(course){return _c('CourseCard',{key:course.id,attrs:{"course":course}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }